import { render, staticRenderFns } from "./monitor-log-table.vue?vue&type=template&id=70e4a801"
import script from "./monitor-log-table.vue?vue&type=script&lang=js"
export * from "./monitor-log-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports